import type { FC, ReactNode } from 'react'
import { createContext, useContext, useMemo } from 'react'
import Axios, { AxiosInstance } from 'axios'

type ContextProps = {
  axiosInstance: AxiosInstance
}

type Props = {
  children: ReactNode
  axiosInstance: AxiosInstance
}

const AxiosContext = createContext<ContextProps>({ axiosInstance: Axios.create() })

export const AxiosInstanceProvider: FC<Props> = ({ children, axiosInstance }) => {
  const value = useMemo(() => ({ axiosInstance }), [axiosInstance])

  return <AxiosContext.Provider value={value}>{children}</AxiosContext.Provider>
}

export const useAxiosInstance = (): AxiosInstance => useContext(AxiosContext).axiosInstance
